module.exports = __webpack_public_path__ + "img/bechbruun2.8d2951f3.jpg";